import { PlayIcon } from '@insta-club/components/icons';
import { cn } from '@insta-club/utilities';

interface CircularPlayButtonProps {
    totalTime: number;
    currentTime?: number;
    onClick?: () => void;
    size?: number;
    className?: string;
}

export default function CircularPlayButton({
    totalTime,
    currentTime = 0,
    onClick,
    size = 27,
    className
}: CircularPlayButtonProps) {
    const time = currentTime;

    const progress = Math.min((time / totalTime) * 100, 100);

    const strokeWidth = 5;
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    const strokeDashoffset = circumference - (progress / 100) * circumference;

    return (
        <div className={cn('relative inline-flex cursor-pointer items-center justify-center', className)}>
            <svg
                width={size}
                height={size}
                className='absolute -rotate-90 cursor-pointer'
                style={{ width: size, height: size }}
            >
                {/* <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    fill='none'
                    stroke='currentColor'
                    strokeWidth={strokeWidth}
                    className=''
                /> */}
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={size <= 27 ? radius : radius - 4}
                    fill='none'
                    stroke='currentColor'
                    strokeWidth={size <= 27 ? strokeWidth : strokeWidth + 2}
                    strokeDasharray={circumference}
                    strokeDashoffset={strokeDashoffset}
                    strokeLinecap='round'
                    className='text-primary-500 transition-all duration-300 ease-linear'
                />
            </svg>

            <button
                onClick={onClick}
                className='bg-primary-200 text-primary-500 relative z-10 flex cursor-pointer items-center justify-center rounded-full transition-all active:scale-95'
                style={{
                    width: size * 0.7,
                    height: size * 0.7
                }}
            >
                <span className='text-lg font-semibold'>
                    <PlayIcon width={size / 3} height={size / 3} />
                </span>
            </button>
        </div>
    );
}

